import {
  CheckedMarkedIcon,
  CloudIcon,
  LeftRightArrowIcon,
  ProcessIcon,
  ScreenIcon,
} from "../../../assets/svgIcons";
import styles from "./OfflineSyncView.module.scss";
import secondaryComponents from "../../secondaryComponents";
import primaryComponents from "../../primaryComponents";
import { useContext, useEffect, useState } from "react";
import { useOfflineModeMutation } from "../../../hooks/api/mutations/offlineMode";
import { ToastContext } from "../../../hooks/context";
import {
  useGetOfflineActiveSync,
  useGetOfflineSyncStatus,
} from "../../../hooks/api/queries/offlineMode";

export const OfflineSyncView = () => {
  const triggerToast = useContext(ToastContext);
  const [currentSync, setCurrentSync] = useState(null);
  const { data: activeSyncData } = useGetOfflineActiveSync();
  const { data: syncData } = useGetOfflineSyncStatus({
    id: currentSync?.id,
  });

  const { mutate: startSync, isLoading: isStartingSync } =
    useOfflineModeMutation();
  const startOfflineSync = () => {
    startSync(
      {},
      {
        onSuccess: (res) => {
          triggerToast("Syncing started successfully", "success");
          setCurrentSync({ id: res?.data?.data?.id, status: "in_progress" });
        },
      },
    );
  };

  useEffect(() => {
    if (activeSyncData) setCurrentSync(activeSyncData);
  }, [activeSyncData]);

  useEffect(() => {
    if (syncData?.status === "completed")
      setTimeout(() => {
        window.location.reload();
      }, 10000);
  }, [syncData]);

  return (
    <>
      <div>
        {!currentSync ? (
          <secondaryComponents.LoaderHelper isLoading={isStartingSync}>
            <secondaryComponents.ToolTipV2
              tipText="Make sure your data is up to date! 
             Connect to the internet to sync your 
             offline and online records."
              position="bottom"
            >
              <div
                className={`${styles.beforeSyncView}`}
                onClick={() => startOfflineSync()}
              >
                <span>
                  <CloudIcon />
                  <LeftRightArrowIcon />
                  <ScreenIcon />
                </span>
                <p className="dark--text cursor-pointer">Start Syncing</p>
              </div>
            </secondaryComponents.ToolTipV2>
          </secondaryComponents.LoaderHelper>
        ) : null}

        {syncData?.status === "in_progress" ||
        syncData?.status === "initiated" ? (
          <secondaryComponents.ToolTipV2
            tipText="Your offline and online records are currently syncing."
            position="bottom"
          >
            <div className={styles.processSyncView}>
              <primaryComponents.Button
                classNames={"btn btn--light-green smallBtn"}
                style={{ padding: "0 5px", width: "35px", height: "30px" }}
              >
                <ProcessIcon
                  className="purple--text"
                  style={{ fontSize: "20px" }}
                />
              </primaryComponents.Button>
              <p className="success--text">Sync In Progress</p>
            </div>
          </secondaryComponents.ToolTipV2>
        ) : null}

        {syncData?.status === "completed" ? (
          <div className={styles.processSyncView}>
            <primaryComponents.Button
              classNames={"btn btn--light-green smallBtn"}
              style={{ padding: "0 5px", width: "35px", height: "30px" }}
            >
              <CheckedMarkedIcon />
            </primaryComponents.Button>
            <p className="success--text">Syncing Successful</p>
          </div>
        ) : null}
      </div>
    </>
  );
};
